var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input-style',{attrs:{"label":_vm.label,"valid":_vm.valid}},[_c('textarea',{class:_vm.flags,domProps:{"value":_vm.value},on:{"input":_vm.input,"focus":function($event){_vm.focus = true},"blur":function($event){_vm.focus = false}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }